<template>
 <div id="chart"></div>  
</template>
<script>
import { statisticsService } from "../../../shared/services";
import ApexCharts from 'apexcharts'

export default {
  props: {
      date: null,
  },
  async mounted() {
    if(!this.date) return;
    await this.YearlyRevenue();
  },
  methods: {
    async YearlyRevenue() {
      var revenueCurrentYear = null;
      var expenseCurrentYear = null;
      try {
        const revenueCurrentYearCall = statisticsService.getRevenue(this.$moment(this.date).year());
        const expenseCurrentYearCall = statisticsService.getExpense(this.$moment(this.date).year());
        const [
          currentYearResult,
          currentYearExpense
        ] = await Promise.all([
          revenueCurrentYearCall,
          expenseCurrentYearCall
        ]);

        this.revenueCurrentYear = currentYearResult;
        this.expenseCurrentYear = currentYearExpense;
      } catch {
        this.ShowToast(
          "Fel",
          "Ett okänt fel uppstod när statistik skulle läsas",
          "danger"
        );
      }

      let sum = 0;
      const ebitCurrentYear = this.revenueCurrentYear.map((r, i) => {return r - this.expenseCurrentYear[i]}).map(elem => sum = (sum || 0) + elem);
      const monthLabels = ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"];

      var options = {
          series: [{
          name: 'Intäkter',
          type: 'column',
          data: this.revenueCurrentYear
        }, {
          name: 'Utgifter',
          type: 'column',
          data: this.expenseCurrentYear
        }, {
          name: 'Ebit',
          type: 'line',
          data: ebitCurrentYear
        }],
          chart: {
          height: 350,
          type: 'line',
          stacked: false,
          toolbar: {
            show: false,
          },
        },
        stroke: {
          width: [0, 0, 5],
          curve: 'smooth'
        },
        plotOptions: {
          bar: {
            columnWidth: '50%'
          }
        },
           colors: ['#5499C7', '#CD6155', '#58D68D', '#F5B041'],
 
        labels: monthLabels,
        markers: {
          size: 0
        },
        xaxis: {
          type: 'text'
        },
        yaxis: {
          min: 0
        },
        tooltip: {
          shared: true,
          intersect: false,
          y: {
            formatter: function (y) {
              if (typeof y !== "undefined") {
                return y.toFixed(0) + " kr";
              }
              return y;
        
            }
          }
        }
        };

        var chart = new ApexCharts(document.querySelector("#chart"), options);
        chart.render();
    }
  }
};
</script>